const actionTypes = {
  SET_SCROLLED_UP: "seneca/classroom/SET_SCROLLED_UP",
  SET_SCROLLED_DOWN: "seneca/classroom/SET_SCROLLED_DOWN",
  SHOW_END_CONTROL_BAR_BUTTONS: "seneca/classroom/OPEN_END_CONTROL_BAR_BUTTONS",
  HIDE_END_CONTROL_BAR_BUTTONS:
    "seneca/classroom/CLOSE_END_CONTROL_BAR_BUTTONS",
  SET_FOCUSED_QUESTION_ID: "seneca/classroom/SET_FOCUSED_QUESTION_ID"
};

export default actionTypes;
